<template>
  <div class="bom-versions-select-by-part-control">
    <Tag v-if="selectedBom && selectedBom.setting">{{ $t('bom_tool.' + selectedBom.setting.bom_type) }}</Tag>
    <BomVersionSelect v-if="selectedBom && selectedBom.id"
                      :bomId="selectedBom.id"
                      :versionId="versionId"
                      :versionNumber="versionNumber"
                      :hasDraft="hasDraft"
                      @versionSelected="handleSelectedBomVersion"
                      :disabled="disabled || (selectedBom.setting && selectedBom.setting.bom_type === 'cost_estimation_use')">
    </BomVersionSelect>
    <Alert show-icon v-else type="warning">
      No versioned BOM associated with the part!
    </Alert>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
import BomVersionSelect from './bom-versions-select'

export default {
  name: 'BomVersionSelectByManufacturerPart',
  components: {
    BomVersionSelect
  },
  props: {
    manufacturerPartId: {
      required: true
    },
    bomType: {
      type: String,
      default: 'engineering_bom'
    },
    strictBomType: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    bomId: {
      type: Number
    },
    versionId: {
      type: Number
    },
    versionNumber: {
      type: String,
      default: 'Draft'
    },
    disabled: {
      type: Boolean
    },
    hasDraft: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedBom: null,
      selectedVersion: null,
      noBomFound: false
    }
  },
  watch: {
    manufacturerPartId: function () {
      this.handleFindBom(this.bomType)
    },
    bomType: function () {
      this.handleFindBom(this.bomType)
    }
  },
  mounted () {
    this.handleFindBom(this.bomType)
  },
  methods: {
    ...mapActions([
      'getBomByComponent'
    ]),
    handleFindBom: function (bomType = 'engineering_bom') {
      if (this.manufacturerPartId) {
        this.loading = true
        let params = { componentId: this.manufacturerPartId, bomType: bomType }
        // If not a strictBomType mode, then will not filter for bomType, only show the default value of given bom type
        this.getBomByComponent(params)
          .then(res => {
            this.selectedBom = res
            if (!res && !this.strictBomType && bomType !== 'engineering_bom') {
              this.handleFindBom('engineering_bom')
            }
          }).finally(() => {
            this.loading = false
            this.handleChange()
          })
      } else {
        this.selectedBom = null
        this.handleChange()
      }
    },
    // async handleGetBomByComponent(bomType = null) {
    //   let selectedBom = await this.getBomByComponent(params)
    //     .then(res => {
    //       this.selectedBom = res
    //       if (!res && !strictBomType) {
    //         selectedBom = this.handleGetBomByComponent(bomType)
    //         this.loading = false
    //       }
    //     }).finally(() => {

    //     })
    //   return selectedBom
    // },
    handleChange () {
      this.$emit('on-change', this.selectedBom, this.selectedVersion)
      this.$emit('update:bomId', this.selectedBom ? this.selectedBom.id : null)
      this.$emit('update:versionId', this.selectedVersion ? this.selectedVersion.version_id : null)
      this.$emit('update:versionNumber', this.selectedVersion ? this.selectedVersion.version : null) // deprecated, use v-model instead.
      this.$emit('input', this.selectedVersion ? this.selectedVersion.version : null)
    },
    handleSelectedBomVersion (bomVersion) {
      if (bomVersion) {
        this.selectedVersion = bomVersion
        this.handleChange()
      } else {
        this.selectedVersion = null
        this.handleChange()
      }
    }
  }
}
</script>
